import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

const getChangePassword = async (params) => {

    const data = {
        passActual: params.oldPassword ? params.oldPassword : null,
        passNueva: params.newPassword ? params.newPassword : null,
    };

    const url = `${ baseUrl }/password`;

    const token = await authHeader();

    return axios
      .post(url,data,
        {
            headers: token 
        }
      )
      .then(response => {
        return response.data;
       }
       )
};

  export default {
    getChangePassword
}